import { defaultSchemes } from "@/utils";
import { z } from "zod";

export const changePasswordScheme = z.object({
  oldPassword: z.string(),
  newPassword: z.string(),
  phone: defaultSchemes.phone,
});

export type ChangePasswordScheme = z.infer<typeof changePasswordScheme>;
